import { Account, MyProfileField } from '../../../state';
import {
  NAME_REGEX,
  NAME_WITH_DIGITS_REGEX,
  PHONE_NUMBER_REGEX,
} from './MyProfileSection.content';
import { FieldMap } from './MyProfileSection.types';

function formatDateOfBirth(dateString?: string): string {
  if (!dateString) return '';

  try {
    const date = new Date(dateString);
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const year = date.getFullYear();

    return `${month}/${day}/${year}`;
  } catch (_) {
    return dateString;
  }
}

export function getLoginInformationInitialState(
  account?: Account,
): MyProfileField[] {
  return [
    {
      locKey: 'myProfileEmail',
      value: account?.email || '',
      isEditable: false,
    },
    {
      locKey: 'myProfilePhoneNumber',
      value: account?.personalDetails?.phoneNumber || '',
      isEditable: false,
    },
    {
      locKey: 'myProfilePassword',
      value: '********',
      isEditable: false,
      targetScreen: 'ChangePasswordScreen',
    },
  ];
}

export function getPersonalInfoInitialState(
  account?: Account,
): MyProfileField[] {
  const fullName =
    account?.personalDetails?.firstName && account.personalDetails.lastName
      ? `${account.personalDetails.firstName} ${account.personalDetails.lastName}`
      : '';

  return [
    {
      locKey: 'myProfileFullName',
      value: fullName,
      isEditable: false,
    },
    {
      locKey: 'myProfileDateOfBirth',
      value: formatDateOfBirth(account?.personalDetails?.birthDate),
      isEditable: false,
    },
    {
      locKey: 'myProfileHomeAddress',
      value: account?.personalDetails?.addressLine1 || '',
      isEditable: false,
    },
    {
      locKey: 'myProfileCountryOfResidence',
      value: account?.personalDetails?.country || '',
      isEditable: true,
      regex: NAME_REGEX,
      regexErrorKey: 'myProfileNameError',
    },
  ];
}

export function getEmployerInformationInitialState(
  account?: Account,
): MyProfileField[] {
  return [
    {
      locKey: 'myProfileEmployerName',
      value: account?.personalDetails?.employer?.name || '',
      isEditable: true,
      regex: NAME_WITH_DIGITS_REGEX,
      regexErrorKey: 'myProfileNameError',
    },
    {
      locKey: 'myProfileEmployerAddress',
      value: account?.personalDetails?.employer?.addressLine1 || '',
      isEditable: true,
      regex: NAME_WITH_DIGITS_REGEX,
      regexErrorKey: 'myProfileNameDigitsError',
    },
    {
      locKey: 'myProfileEmployerCity',
      value: account?.personalDetails?.employer?.city || '',
      isEditable: true,
      regex: NAME_REGEX,
      regexErrorKey: 'myProfileNameError',
    },
    {
      locKey: 'myProfileEmployerProvince',
      value: account?.personalDetails?.employer?.province || '',
      isEditable: true,
      regex: NAME_REGEX,
      regexErrorKey: 'myProfileNameError',
    },
    {
      locKey: 'myProfileEmployerCountry',
      value: account?.personalDetails?.employer?.country || '',
      isEditable: true,
      regex: NAME_REGEX,
      regexErrorKey: 'myProfileNameError',
    },
    {
      locKey: 'myProfileEmployerPostalCode',
      value: account?.personalDetails?.employer?.postalCode || '',
      isEditable: true,
      regex: NAME_WITH_DIGITS_REGEX,
      regexErrorKey: 'myProfileNameDigitsError',
    },
    {
      locKey: 'myProfileEmployerPhoneNumber',
      value: account?.personalDetails?.employer?.phoneNumber || '',
      isEditable: true,
      regex: PHONE_NUMBER_REGEX,
      regexErrorKey: 'myProfilePhoneError',
    },
    {
      locKey: 'myProfileEmployerPhoneExtension',
      value: account?.personalDetails?.employer?.phoneExtension || '',
      isEditable: true,
    },
  ];
}

export function parseFieldData(fieldData: MyProfileField[]) {
  return fieldData.reduce((acc: FieldMap, item) => {
    acc[item.locKey] = item.value;
    return acc;
  }, {});
}
